"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitPql = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _links = require("self-service-api/core/utilities/links");

var _submitForm = require("ui-addon-upgrades/_core/common/api/submitForm");

var _createPqlFormData = require("ui-addon-upgrades/_core/common/data/pqlData/createPqlFormData");

var _getUserInfo = require("ui-addon-upgrades/_core/common/api/getUserInfo");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _wrapWithErrorMonitoring = _interopRequireDefault(require("ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring"));

var _getPqlFormAttributes = require("ui-addon-upgrades/_core/pql/getPqlFormAttributes");

var submitPql = (0, _wrapWithErrorMonitoring.default)('submitPql', function (pqlData) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var formAttributes = (0, _getPqlFormAttributes.getPqlFormAttributes)();
  var formEndpoint = (0, _links.formUrl)(formAttributes);
  return (0, _getUserInfo.getUserInfo)().then(function (_ref) {
    var portal = _ref.portal,
        user = _ref.user;
    var metaData = {
      timestamp: _I18n.default.moment().valueOf()
    };
    var pqlFormData = (0, _createPqlFormData.createPqlFormData)({
      metaData: metaData,
      upgradeData: pqlData,
      user: user,
      portal: portal,
      options: options
    });
    return (0, _submitForm.submitForm)(formEndpoint, pqlFormData);
  }).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.trackBeforeUnload('pqlInteraction', Object.assign({
      action: 'submission succeeded'
    }, pqlData));
  }).catch(function (error) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.trackBeforeUnload('pqlInteraction', Object.assign({
      action: 'submission failed'
    }, pqlData));
    throw error;
  });
});
exports.submitPql = submitPql;